module.exports = __webpack_public_path__ + "static/media/Renewal&Modification – Arabic@2x.2746129d.jpg";